<div class="content">
    <div class="content-header p-d-flex p-jc-between p-ai-center">
        <div class="title">
            <h1>Edición de una configuración de presorteo</h1>
            <p>Espacio para editar una configuración de presorteo</p>
        </div>
        <div class="button">
            <p-button label="Regresar" icon="pi pi-angle-left" (click)="goBack()"></p-button>
        </div>
    </div>
    <div class="content-body">
        <app-config-presorteo-edit *ngIf="configPresorteo != null" [config]="configPresorteo" [type]="type"></app-config-presorteo-edit>
    </div>
</div>
